@if (links?.length > 0) {
  <sd-social-media [data]="links" [brand]="brandCorner" />
}
